import React, { useState, useEffect } from 'react';
import useLoyaltyStore from './useLoyaltyStore';
import RewardsTab from './RewardsTab';
import PartnersTab from './PartnersTab';
import CategoriesTab from './CategoriesTab';
import MissionsTab from './MissionsTab';

const TABS = [
  { key: 'rewards', label: 'Rewards' },
  { key: 'partners', label: 'Partners' },
  { key: 'categories', label: 'Categories' },
  { key: 'missions', label: 'Missions' },
];

const LoyaltyManagement = ({ partners: initialPartners, categories: initialCategories }) => {
  const [activeTab, setActiveTab] = useState('rewards');
  const { fetchRewards, fetchPartners, fetchCategories } = useLoyaltyStore();

  useEffect(() => {
    fetchRewards();
    fetchPartners();
    fetchCategories();
  }, []);

  const renderTab = () => {
    switch (activeTab) {
      case 'rewards':
        return <RewardsTab initialPartners={initialPartners} initialCategories={initialCategories} />;
      case 'partners':
        return <PartnersTab />;
      case 'categories':
        return <CategoriesTab />;
      case 'missions':
        return <MissionsTab />;
      default:
        return null;
    }
  };

  return (
    <div>
      <ul className="nav nav-tabs" role="tablist">
        {TABS.map(tab => (
          <li className="nav-item" key={tab.key}>
            <a
              className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
              href="#"
              onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
              role="tab"
            >
              {tab.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content p-4">
        {renderTab()}
      </div>
    </div>
  );
};

export default LoyaltyManagement;
